/* 에러 코드 참조 DOCUMENT: https://www.notion.so/plexgathering/6ea09df793444e0e8d97c9b32596998c?pvs=4 */

export const ERROR_CODE = {
  /* US: User */
  /**
   * 비밀번호 불일치
   * */
  US003: "US003",
  /**
   * 회원가입 후 이메일 미인증
   * */
  US004: "US004",
  /**
   * stay 가입자가 처음 fip user 조회 시 발생하는 에러
   * */
  US005: "US005",
  /**
   * 핸드폰 verify에 실패한 경우
   * */
  US007: "US007",
  /**
   * 만료된 토큰으로 요청시 발생하는 에러 코드
   */
  US009: "US009",

  /* EV: Event */
  /**
   * 피차단자가 차단자에게 인터랙션을 시도한 경우 에러 코드 (ex. 차단자의 이벤트 참여 시도 등)
   */
  EV008: "EV008",

  /* EV: Event Not Found */
  /**
   * 이벤트가 없는 경우
   */
  EV006: "EV006",
  /**
   * 동일할 시간대에 참여한 이벤트가 있는 경우
   */
  EV011: "EV011",

  /* EVCR: Event Chat Room */
  /**
   * 참여하지 않은 이벤트에 대한 채팅방 접근 시도 에러 코드
   */
  EVCR002: "EVCR002",

  /* EVCR: Event Chat Room */
  /**
   * 최대 이미지 개수를 전송한 경우 에러 코드
   */
  EVCR004: "EVCR004",
} as const;

export const ERROR_MESSAGE = {
  [ERROR_CODE.US003]: "The entered password is incorrect. Please try again.",
} as const;
